<ng-container *transloco="let t">
  <div class="step-container">
    <div class="step-content">
      <!-- Logos Section -->
      <div class="logos-container" [class.single-logo]="!partnerIconUrl">
        @if (partnerIconUrl) {
          <div class="logo-circle partner">
            <img
              [src]="partnerIconUrl"
              [alt]="partnerName"
              class="logo-image-partner" />
          </div>
          <div class="link-connector">
            <mzic-svg src="assets/icons/mzic-link-icon.svg" />
          </div>
        }
        <div class="logo-circle mzic">
          <mzic-svg src="assets/icons/mzic-logo-purple.svg" />
        </div>
      </div>

      <!-- Greeting -->
      <p class="greeting-name">
        {{ t('lang.greeting_name', { name: displayName }) }}
      </p>

      <!-- Main Message -->
      <div class="main-message">
        <h1 class="main-title">
          {{
            t(mainTitleKey, {
              partner: partnerName,
              entity: integrationEntityName,
            })
          }}
        </h1>
        <p class="main-description">
          {{
            t(mainDescriptionKey, {
              partner: partnerName,
              entity: integrationEntityName,
            })
          }}
        </p>
      </div>

      <!-- Info Cards -->
      <div class="info-cards">
        <div class="info-card">
          <div class="info-icon check">
            <mzic-svg src="assets/icons/mzic-check-mark-filled.svg" />
          </div>
          <div class="info-content">
            <h3 class="info-title">{{ t('lang.info_card_1_title') }}</h3>
            <p class="info-text">
              {{ t(infoCard1TextKey, { entity: integrationEntityName }) }}
            </p>
          </div>
        </div>

        <div class="info-card">
          <div class="info-icon lock">
            <mzic-svg src="assets/icons/mzic-lock.svg" />
          </div>
          <div class="info-content">
            <h3 class="info-title">{{ t('lang.info_card_2_title') }}</h3>
            <p class="info-text">{{ t('lang.info_card_2_text') }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="step-footer">
      <button class="primary-button" (click)="onContinue()" [disabled]="loading">
        @if (loading) {
          <mzic-spinner />
        }
        {{ t('lang.button_start') | uppercase }}
      </button>
    </div>
  </div>
</ng-container>
